var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.6 640.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #231f20;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6, .cls-3 {\n        fill: #274143;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-2 {\n        stroke: #274143;\n        stroke-width: 4px;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-12 {\n        fill: #737c7f;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 354.57,
    y1: 431.24,
    x2: 440.6,
    y2: 410.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#73644e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b0824d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d9974d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e69d4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#df9a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d2934b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#bf8b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a77f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8a7048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#665f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f4c44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 53.45,
    y1: 399.39,
    x2: 139.25,
    y2: 422.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73644e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#866d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#bb884d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#dc984d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e49c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d7964c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c18b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a27c49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#7b6947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4b5244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 326.57,
    y1: 588.18,
    x2: 326.83,
    y2: 494.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#73644e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#836c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#af824d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ce914d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e29b4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#e69d4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#df9a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d2934b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#bf8b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#a77f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8a7048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#665f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#3f4c44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 198.98,
    y1: 602.68,
    x2: 195.16,
    y2: 509.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#73644e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b0824d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d9974d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e69d4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#df9a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#d2934b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#bf8b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#a77f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#8a7048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#665f46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3f4c44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 258.61,
    y1: 69.68,
    x2: 259.31,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e79e4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e09a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d4954b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c38c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ad8249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#927548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#716546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4d5344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 383.4,
    y1: 220.41,
    x2: 421.8,
    y2: 220.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#274143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#284143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2f4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3b4947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3e4a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#494f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5b584b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#73644e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7d694d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9a774d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c98f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e99f4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 88.12,
    y1: 220.47,
    x2: 120.97,
    y2: 220.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e79e4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e09a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d4954b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#c38c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ad8249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#927548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#716546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4d5344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 258.77,
    cy: 207.28,
    fx: 258.77,
    fy: 207.28,
    r: 136.25,
    gradientTransform: "translate(0 16.45) scale(1 .92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed3a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fcd1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f5cda5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e9c6a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d8bb9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c2ad96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#a79c8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#878985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737c7f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "352.57 340.91 359.7 340.03 368.53 341.24 375.54 343.57 383.18 347.46 389.35 351.88 394.91 357.42 398.92 363.44 400.31 368.2 399.96 372.42 398.92 374.87 403.4 376.51 407.78 378.65 410.91 380.74 415.77 385.32 419.76 390.85 423.81 398.81 439.56 432.35 440.59 437.25 440.41 441.19 438.74 446.83 435.9 451.21 432.42 454.31 435.99 458.37 439.14 464.34 440.59 469.23 440.92 475.28 441.17 481.42 440.39 486.56 438.18 492.67 435.33 497.14 432.31 500.29 427.46 503.54 422.71 505.31 416.95 506.17 411.18 505.3 407.26 502.7 404.61 499.19 403.65 495.03 400.87 464.75 401.75 459.39 401.9 455.48 401.61 450.51 379.01 389.4 377.55 384.93 369.84 368.5 365.1 358.75 361.09 351.86 356.61 345.52 352.57 340.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "164.84 337.53 158.42 336.61 148.81 337.79 138.13 341.77 126.2 349.93 119.62 357.61 117.89 361.03 116.93 366.15 118.31 371.45 114.22 372.93 106.99 376.81 101.13 382.28 96.38 389.31 77.51 429.25 76.64 435.69 77.62 441.27 79.34 445.04 82.44 448.96 84.81 450.88 81.64 454.38 78.57 459.77 77.01 463.99 76.04 474.71 76.19 479.41 77.76 486.24 80.66 492.04 83.94 495.98 88.31 499.33 93.04 501.46 99.24 502.66 103.25 502.66 106.91 501.47 109.63 499.59 112.14 496.84 113.48 493.94 116.38 460.56 116.15 453.13 116.74 448.92 135.95 384.48 138.81 377.58 143.89 366.6 148.52 357.75 154.06 349.04 160.27 341.61 164.84 337.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m298.29,524.13c-.91.33-1.95.77-3.08,1.36-.57.29-1.6.85-2.82,1.67-.75.51-1.91,1.35-3.22,2.53-1.12,1.02-2,1.99-2.66,2.77-.62.74-1.34,1.67-2.08,2.81-.75,1.16-1.27,2.14-1.56,2.71-.63,1.27-1.06,2.36-1.34,3.13-.36,1.02-.6,1.86-.73,2.37-.32,1.26-.5,2.31-.6,3.03-.03.23-.15,1.07-.22,2.28-.09,1.47-.06,2.53-.04,3.35.04,1.82.02,3.14,0,5.37-.03,2.85-.12,3.63.02,5.51.08,1.09.19,1.93.44,2.89.18.68.49,1.68,1.04,2.81.31.64.83,1.57,1.64,2.58.41.52,1.06,1.26,1.96,2.04.82.7,1.56,1.17,2,1.44.69.41,1.53.83,2.52,1.19.26.09,1.23.43,2.59.67,2.1.36,3.79.22,4.26.19,4.41-.32,8.84.02,13.27,0h43.98c.35,0,2.57.04,5.16,0,.64-.01,1.6-.03,2.82-.28.71-.14,1.33-.32,1.83-.49.64-.22,1.53-.57,2.51-1.12,1.15-.65,2-1.34,2.54-1.82.44-.39,1.11-1.05,1.82-1.96.83-1.08,1.34-2.04,1.59-2.57.33-.68.77-1.73,1.07-3.07.23-1.01.28-1.77.35-2.72.09-1.28.04-1.93.01-3.72,0-.52,0-1.74,0-4.17,0-3.56.04-3.63,0-4.68-.06-1.58-.1-2.76-.35-4.31-.14-.9-.53-3.02-1.53-5.59-.37-.96-1.08-2.61-2.25-4.51-.78-1.27-2.11-3.2-4.14-5.23-1.18-1.18-2.46-2.12-5.02-3.99-2.89-2.12-3.88-2.57-5.04-2.47-.44.04-.41.11-2.26.52-1.47.32-2.35.46-3.06.6-2.82.53-3.19.99-5.29,1.42-2.32.47-2.21-.03-5.89.3-3.09.28-3.24.63-6.11.82-.57.04-1.08.06-5.07,0-4.08-.06-6.12-.09-7.08-.15-2.25-.14-1.95-.24-7.3-.82-4.68-.51-4.78-.42-6.63-.75-2.69-.47-5.22-1.14-5.96-1.34-.85-.23-1.57-.44-2.09-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m168.21,523.94c-1.46.1-2.44,1.12-3.35,2-4.13,4.01-4.09,2.67-6.9,5.81-2.74,3.07-4.21,5.95-4.69,6.95-1.76,3.65-2.36,6.82-2.59,8.37-.2,1.33-.12,1.51-.22,6.49-.15,7.86-.35,8.95.24,11.47.35,1.45.84,3.43,2.31,5.58,1.6,2.34,3.52,3.65,4.5,4.23,1.06.64,2.56,1.34,5.05,1.87,4.13.87,7.25.44,10.13.21,4.01-.33,8.05.03,12.07,0,8.29-.06,14.8-.02,20.94,0,5.86.02,11.78-.82,17.59,0,0,0,3.81.54,8.17-.16.94-.15,2.29-.43,3.83-1.13.56-.25,1.44-.7,2.43-1.39,1.13-.8,1.92-1.6,2.36-2.09.4-.44.99-1.14,1.58-2.09.71-1.15,1.12-2.15,1.33-2.74.2-.55.52-1.56.74-3.08.25-1.77.17-2.92.12-4.78-.1-3.52.09-2.94,0-7.38-.05-2.61-.08-3.91-.2-5.06-.25-2.52-.47-4.74-1.59-7.31-.68-1.57-1.39-2.59-2.67-4.4-1.07-1.53-2.26-3.19-4.21-5.03-.8-.75-2.3-1.8-5.3-3.91-2.2-1.54-3.44-2.33-4.89-2.08-.33.06-.3.11-1.49.51,0,0-1.59.54-3.58,1.04-1.85.47-3.36.6-6.11.89-6.04.65-5.15.71-7.75.89-3.05.22-5.42.22-7.3.22-1.32,0-3.37-.02-5.89-.15-2.01-.1-3.4-.22-6.04-.45-2.01-.17-3.73-.32-6.04-.6-2.37-.28-3.58-.43-5.14-.75-1.94-.4-2.91-.59-4.25-1.04-1.84-.62-2.26-1-3.22-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m220.64,326.71s-12.91-.46-24.31.21c-9.64.56-11.05,1.32-13.94,2.1-7.78,2.11-12.58,5.08-13.94,5.95-.77.49-3,1.95-5.61,4.23-1.36,1.18-3.75,3.39-6.87,7.31-4.22,5.29-6.72,9.87-9.2,14.47-1.52,2.8-2.95,5.85-5.8,11.93-2.17,4.63-3.16,6.91-4.12,9.47-1.25,3.31-1.99,5.82-2.58,7.77-2.27,7.64-4.57,15.27-6.83,22.92,0,0-1.37,4.58-4.1,13.74-1.97,6.61-2.96,9.91-2.96,9.91-1.94,5.92-2.9,7.85-3.64,12.2-.55,3.25-.6,5.56-.58,6.93.02,1.08.1,3.5.71,6.54.28,1.41.91,4.16,2.31,7.43.41.97,1.39,3.15,3.05,5.74.93,1.45,3.25,4.87,7.16,8.4.92.83,3,2.64,5.98,4.51,1.26.79,3.72,2.25,7.06,3.61,1.34.55,3.81,1.47,7.03,2.21.8.18,3.3.74,6.92,1.05,4.45.39,7.84.19,8.56.15,24.21-1.33,48.5.17,72.75,0,40.79-.28,61.18-.42,67.98,0,17.37,1.08,34.81,0,52.22,0,.95,0,4.05,0,8.01-.67,3.29-.55,5.85-1.35,7.29-1.84,2.13-.72,3.78-1.46,4.74-1.91,2.3-1.08,4.05-2.14,5.08-2.8,1.71-1.09,2.99-2.08,3.73-2.67,1.82-1.46,3.14-2.75,3.8-3.42,1.81-1.84,3.06-3.45,3.69-4.29.48-.64,1.73-2.36,3.08-4.8,1.22-2.19,2.63-4.74,3.59-8.35.89-3.35.95-5.96,1.02-9.28.06-2.87-.14-4.2-.29-4.97-.23-1.23-.57-1.79-1.95-5.46-.41-1.09-.8-2.18-1.21-3.27-.03-.08,0-.01-4.04-10.93-5.16-13.97-8.58-25.73-15.85-42.88-.79-1.87-1.43-3.33-2.72-6.26-5.15-11.75-7.8-17.75-11.39-24.11-1.48-2.62-3-5.35-5.2-8.51-2.61-3.75-4.66-6.01-5.24-6.65-1.02-1.12-2.68-2.91-5.15-4.95-3.39-2.8-6.37-4.46-7.55-5.09-.92-.49-3.33-1.73-6.65-2.87-3.76-1.29-6.73-1.78-9.35-2.19-3.37-.54-4.9-1-9.88-.94-11.33.15-18.56.22-18.56.22-.38.67.39,1.28-.15,2.39-.3.61-2.63,2.53-3.65,2.91-4.69,1.72-7.69,2.87-12,3.61q-5.72.98-10.11,1.48c-.95.11-3.28.77-7.85.79-4.37.03-6.56.04-7.83,0-5.22-.15-9.21-.64-10.58-.82-3.63-.47-6.13-.99-9.24-1.64-4.6-.96-5.86-1.44-7.01-2.01-2.05-1.03-2.97-1.79-4.25-2.39-1.63-.75-2.09-1.22-2.63-2.29-.49-.96-.72-1.28-.92-1.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "288.63 495.5 364.68 495.03 364.33 496.94 361.36 499.9 359.64 500.88 362.51 502.36 364.68 504.56 364.38 507.57 362.11 510.13 359.59 511.61 363.19 514 364.63 516.49 363.79 519.29 360.68 521.77 355.03 524.13 344.42 526.66 332.42 527.78 320.27 527.63 310.56 526.56 304.08 525.62 298.29 524.13 293.07 522.02 289.83 519.66 288.63 516.98 289.57 514.51 291.69 512.83 293.73 511.61 291.09 510.05 288.99 507.69 288.63 504.78 290.68 502.32 293.78 500.63 290.57 499.42 288.89 497.07 288.63 495.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "159.14 495.5 235.19 495.5 234.3 497.82 231.66 500.03 230.09 500.88 232.55 502.06 234.64 503.98 235.07 507.04 232.91 509.91 230.1 511.61 233.35 513.68 235.19 515.85 234.7 518.69 232.74 520.77 228.11 523.21 225.02 524.29 218.57 525.8 212.2 526.7 206.09 527.63 198.78 527.85 190.27 527.54 182.2 526.81 175.68 525.91 170.05 524.57 166.02 523.23 161.67 520.83 159.42 518.26 159.14 515.85 160.88 514.06 164.23 511.61 161.95 510.29 159.88 508.36 158.98 506.25 159.99 503.55 162 502.1 164.24 500.88 161.33 499.3 159.65 497.29 159.14 495.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "294.15 434.85 288.63 437.07 284.98 440.5 282.97 445.08 282.61 447.99 282.97 451.57 284.2 455.03 286.88 458.27 289.45 460.17 293.37 461.29 297.61 461.63 300.97 460.84 304.43 458.94 307.45 455.48 309.02 452.12 309.45 447.2 308.57 442.84 306.34 439.94 303.32 437.25 300.41 435.69 296.83 434.85 294.15 434.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "223.28 323.36 220.64 326.71 221.57 328.64 224.2 330.93 230.98 334.06 238.25 335.52 247.08 336.97 255.28 337.79 263.11 337.79 272.35 336.86 281.07 335.52 286.88 334.29 291.8 332.16 296.72 328.99 296.87 326.61 295.5 323.76 291.96 321.43 288.18 323.13 280.29 325.12 270.22 326.35 263.87 326.71 255.8 326.7 248.44 326.38 240.92 325.51 234.27 324.14 228.69 322.37 226.22 321.5 223.28 323.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "257.25 326.71 252.89 326.66 243.13 325.82 233.05 323.9 226.22 321.5 222.1 318.63 220.92 316 221.87 313.5 223.98 311.61 225.59 310.45 232.66 313.27 232.66 313.27 240.43 314.65 252.89 315.93 261.73 315.99 273.23 315.29 282.97 313.6 288.45 312.15 292.92 310.7 295.44 312.59 296.82 314.5 296.82 317.23 295.45 319.15 291.96 321.43 286.99 323.66 280.29 325.12 274.25 325.79 268.88 326.38 263.87 326.71 257.25 326.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "296.72 306.73 292.92 310.7 280.43 314.21 273.23 315.29 263.41 316 252.89 315.93 244.17 315.22 238.02 314.28 230.62 312.47 225.59 310.45 221.96 307.72 220.92 305.04 297.38 305.04 296.72 306.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "253.51 67.42 253.27 91.32 264.55 91.32 264.55 66.95 262.36 68.29 258.91 68.6 256.47 68.29 253.51 67.42 253.5 68.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "226.88 109.27 291.26 109.42 290.57 104.57 288 99.13 283.2 94.4 277.34 91.8 271.75 91.26 253.27 91.32 243.27 91.35 238.33 92.56 234.63 94.81 230.91 97.94 228.37 101.37 226.88 105.39 226.88 109.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "396.82 179.63 398.38 184.67 400.7 193.64 402.04 203.03 402.42 213.44 402.34 238.66 401.44 246.56 399.62 254.46 396.82 261.18 401.79 261.02 407.07 259.68 413.26 256.66 418.48 252.56 423.85 245.99 427.09 239.67 428.93 233.75 429.93 227.63 429.93 221.22 429.93 210.63 426.99 201.19 422.57 193.29 416.2 186.59 412.02 183.5 407.11 181.42 401.29 179.78 396.82 179.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "115.53 179.95 108.77 182.06 103.36 185.15 99.28 188.57 95.12 193.5 91.84 199.16 89.92 204.13 88.58 210.04 88.12 218.39 88.38 229.29 90 236.98 92.74 243.49 97.38 250.25 102.79 255.29 108.02 258.45 113.65 260.48 117.6 261.2 120.75 261.32 117.76 254.31 115.88 244.76 114.78 233.14 114.86 221.7 114.86 209.89 116.25 196.43 117.47 190.06 119.36 184.14 120.97 179.61 115.53 179.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m304.55,109.74h-91.84l-8.6.85-11.85,2.38-13.57,4.6-10.25,4.97-9.65,6.07-8.98,7.13-6.69,6.5-5.53,6.37-7.17,10.14-5.96,11.05-3.49,9.83-2.95,8.31-1.77,8.5-1.09,9.16-.29,9.86v14.09l.33,11.05,1.6,9.67,2.64,8.63,2.39,5.6,3.77,6.88,4.52,6.44,5.21,5.91,6.32,5.71,5.12,3.74,6.61,3.9,5.7,2.64,5.22,1.91,8.61,2.19,7.56,1.01,11.13.23h28.56s.78,0,.78,0c.28,0,6.9,0,7.27,0h63.61c1.86,0,3.72,0,5.58,0,11.24,0,22.49,0,33.73,0,3.99-.33,7.99-.67,11.98-1l8.81-2.08,8.85-3.36,7.96-4.28,7.43-5.31,5.88-5.36,4.69-5.29,6.08-8.85,4.77-9.89,2.48-7.59,1.61-7.85.75-8.95v-9.06l.02-10.96-.33-10.06-.73-6.58-2.98-13.91-4.18-11.78-5.21-10.57-5.28-8.37-6.26-8.08-7-7.4-10.72-8.99-9-5.88-8.72-4.54-9.84-3.94-5.6-1.99-6.04-1.34-7.27-1.45-8.72-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m203.25,134.94c-2.78.24-4.77.68-7.71,1.34-2.1.47-5.2,1.17-9.17,2.57-2.08.73-5.01,1.78-8.61,3.69-3.23,1.71-5.54,3.34-7.6,4.81-1.13.8-2.97,2.11-5.25,4.02-3.14,2.64-5.3,4.89-6.6,6.26-1.02,1.08-2.69,2.84-4.7,5.37-1.33,1.67-2.72,3.41-4.25,5.93-1.49,2.44-2.35,4.35-3.47,6.82-1.14,2.53-2.03,4.5-2.91,7.27-1.02,3.23-1.45,5.73-2.01,9.06-.41,2.43-.79,4.6-1.01,7.49-.26,3.42.02,3.58,0,11.18,0,2.9-.05,5.52-.11,8.83-.05,2.81-.07,4.21-.11,5.81-.09,3.88-.14,4.67-.11,6.37.02.96.07,3.39.34,5.81.19,1.79.77,5.98,2.57,11.07.64,1.81,1.8,5.03,4.14,8.83,1.65,2.69,3.23,4.59,4.25,5.81,1.15,1.37,2.72,3.24,5.14,5.37.91.79,3.18,2.72,6.48,4.7.52.31,2.8,1.65,6.04,3.02,1.77.75,4.13,1.73,7.38,2.46,2.82.64,5,.79,6.6.89,4.18.27,4.98-.19,11.4-.22,2.09-.01,3.7.03,6.93.11,3.65.09,4.68.17,7.49.22,3.31.06,5.68.02,7.38,0,1.62-.02,6.9-.01,17.44,0,14.11.02,12.74.15,21.24.11,8.54-.03,9.21-.16,19.57-.22,2.9-.02,7.53-.01,16.66,0,19.57.03,25.81.07,29.85.11,1.53.01,4.3.1,9.84.11,1.76,0,3.72,0,6.26-.45.64-.11,1.85-.41,4.25-1.01,3.32-.82,5-1.24,6.04-1.57,2.48-.77,3.8-1.19,5.48-2.12.77-.43.86-.55,4.36-3.13,3.59-2.65,3.39-2.45,4.25-3.13,1.3-1.04,3.07-2.47,5.03-4.58,1.91-2.06,3.1-3.82,4.14-5.37,1.22-1.82,2.43-3.63,3.58-6.26.7-1.6,1.1-2.88,1.68-4.7.42-1.32.96-3.06,1.45-5.37.2-.94.68-3.21.89-5.93.29-3.63-.01-6.4-.11-7.38-.61-6.23.26-6.45,0-20.24-.04-2.13-.15-6.84-.67-12.86-.41-4.68-.74-6.41-1.12-7.94-.28-1.11-.69-2.53-3.58-9.28-2.15-5.03-3.23-7.54-4.14-9.17-2.16-3.86-4.29-6.51-5.81-8.39-1.43-1.76-4.17-4.97-8.16-8.5-7.9-6.98-15.54-10.64-19.12-12.19-4.16-1.8-7.71-2.84-9.61-3.35-2.26-.61-4.97-1.22-8.05-1.68-.9-.13-4.66-.67-10.96-.78-2.93-.05-3.31.05-10.17.22-5.96.16-9.54.25-14.09.22-5.37-.03-5.22-.19-11.29-.22-3.54-.02-4.9.03-11.85.11-6.3.08-9.45.11-11.96.11-7.57,0-8.86-.17-19.45-.22-3.8-.02-5.94,0-6.93,0-5.27.03-5.44.12-9.06.11-5.76,0-5.91-.21-8.39,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 191.57,
    cy: 221.7,
    rx: 21.43,
    ry: 19.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 327.05,
    cy: 221.7,
    rx: 21.43,
    ry: 19.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m276,228.6c-2.9,3.6-7.6,6.44-16.97,6.44s-14.07-2.84-16.97-6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m218.74,109.57h79.8c57.33,0,103.88,46.55,103.88,103.88v20.28c0,39.36-31.95,71.31-71.31,71.31h-144.94c-39.36,0-71.31-31.95-71.31-71.31v-20.28c0-57.33,46.55-103.88,103.88-103.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.61,134.9h98.07c38.51,0,69.77,31.26,69.77,69.77v28.53c0,25.66-20.83,46.49-46.49,46.49h-144.63c-25.66,0-46.49-20.83-46.49-46.49v-28.53c0-38.51,31.26-69.77,69.77-69.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m245.09,91.26h27.87c10.1,0,18.3,8.2,18.3,18.3h-64.48c0-10.1,8.2-18.3,18.3-18.3Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "264.55 66.76 264.55 90.88 253.5 90.88 253.5 66.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 259.03,
    cy: 57.45,
    r: 11.16
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m296.35,326.71h19.89c39.43,0,48.44,31.27,61.65,59.45l23.69,64.07c3.17,24.07-17.29,45.27-43.7,45.27h-197.7c-26.78,0-47.36-21.78-43.57-46.13l19.35-64.89c16.78-40.13,28.53-57.76,67.32-57.76h17.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m291.96,321.43c3.24,1.58,5.09,3.41,5.09,5.37,0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73c0-1.85,2.29-3.78,5.22-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m292.01,310.7c4.1,1.71,5.04,3.14,5.04,5.37,0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73c0-2.1,1.47-3.97,5.15-5.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m297.05,305.34c0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.36,524.31c10.77,3.73,18.51,13.96,18.51,26v12.07c0,8.03-6.51,14.54-14.54,14.54h-64.33c-8.03,0-14.54-6.51-14.54-14.54v-12.07c0-11.39,8.2-22.09,18.07-26.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m235.19,495.52c0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m230.15,500.88c4.1,1.71,5.04,3.14,5.04,5.37,0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73c0-2.1,1.47-3.97,5.15-5.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m230.1,511.61c3.24,1.58,5.09,3.41,5.09,5.37,0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73c0-1.85,2.29-3.78,5.22-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m355.03,524.13c10.52,3.86,18.33,14.24,18.33,26.1v12.07c0,8.03-6.51,14.54-14.54,14.54h-64.33c-8.03,0-14.54-6.51-14.54-14.54v-12.07c0-11.86,7.81-22.24,18.33-26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m364.68,495.52c0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m359.64,500.88c4.1,1.71,5.04,3.14,5.04,5.37,0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73c0-2.1,1.47-3.97,5.15-5.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m359.59,511.61c3.24,1.58,5.09,3.41,5.09,5.37,0,5.93-17.02,10.73-38.02,10.73s-38.02-4.81-38.02-10.73c0-1.85,2.29-3.78,5.22-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m400.87,464.75l26.65-8.11c9.85-3,15.31-13.73,12.19-23.97l-17.89-38.09c-6.86-13.57-15.03-17.1-22.9-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m379.01,389.4l17.7-12.24c4.43-2.89,4.83-10.11.91-16.12h0c-9.8-15.02-31.93-24.02-45.22-20.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m400.85,463.98l2.81,31.1c.61,6.73,6.56,11.7,13.29,11.09l1.6-.14c13.78-1.24,22.8-12.62,22.7-27.21l-1.03-11.42c-1.7-5.52-4.22-9.91-7.8-13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m116.35,461.33l-26.65-8.11c-9.85-3-15.31-13.73-12.19-23.97l17.89-38.09c6.86-13.57,15.03-17.1,22.9-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.95,384.48l-15.43-10.74c-4.43-2.89-4.83-10.11-.91-16.12h0c9.8-15.02,31.93-24.02,45.22-20.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m116.38,460.56l-2.81,31.1c-.61,6.73-6.56,11.7-13.29,11.09l-1.6-.14c-13.78-1.24-22.8-12.62-22.7-27.21l1.03-11.42c1.7-5.52,4.22-9.91,7.8-13.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 337.19,
    cy: 448.26,
    r: 13.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 296.03,
    cy: 448.26,
    r: 13.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 255.31,
    cy: 448.26,
    r: 13.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.22,416.72h-91.89c-7.4,0-13.41-6-13.41-13.41v-31.15c0-7.4,6-13.41,13.41-13.41h69.6c9.26,0,17.59,5.61,21.06,14.19l11.53,28.47c2.96,7.31-2.42,15.29-10.31,15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.16,473.68h-36.72c-12.21,0-21.16-11.51-18.14-23.34l18.72-73.51c2.86-11.22,12.96-19.07,24.53-19.07h16.32c7.25,0,13.12,5.87,13.12,13.12v84.98c0,9.85-7.98,17.83-17.83,17.83Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullRobot);
export default __webpack_public_path__ + "static/media/Full_robot.12e864c94d1974507bd7379b33d73924.svg";
export { ForwardRef as ReactComponent };